export const categories = [
  {
    id: "shoes",
    name: "Shoes",
    namePl: "Buty",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    imageUrl:
      "https://readdy.ai/api/search-image?query=Contemporary%20sneakers%20and%20fashionable%20footwear%20neatly%20displayed%20on%20a%20clean%20minimal%20white%20surface%2C%20soft%20natural%20diffused%20lighting%2C%20product%20photography%20style%20with%20shallow%20depth%20of%20field%2C%20aesthetic%20warm%20neutral%20background%20with%20subtle%20fabric%20textures%2C%20elegant%20simplicity&width=160&height=160&seq=cat-img-shoes-2026&orientation=squarish",
  },
  {
    id: "hoodies",
    name: "Hoodies/Sweaters",
    namePl: "Bluzy/Swetry",
    url: "https://kaspreadsheet.com/search-912/name/Shoes.html",
    imageUrl:
      "https://readdy.ai/api/search-image?query=Premium%20quality%20hoodie%20and%20cozy%20sweater%20neatly%20folded%20on%20a%20minimal%20wooden%20surface%2C%20warm%20ambient%20lighting%20from%20a%20table%20lamp%2C%20neutral%20cream%20wall%20background%2C%20editorial%20fashion%20photography%20with%20soft%20organic%20shadows%20and%20comfortable%20aesthetic&width=160&height=160&seq=cat-img-hoodies-2026&orientation=squarish",
  },
  {
    id: "tshirts",
    name: "T-Shirts",
    namePl: "Koszulki",
    url: "https://kaspreadsheet.com/search-913/name/Shoes.html",
    imageUrl:
      "https://readdy.ai/api/search-image?query=Collection%20of%20soft%20cotton%20t-shirts%20in%20warm%20earthy%20tones%20artfully%20arranged%20on%20a%20light%20linen%20surface%2C%20gentle%20daylight%20streaming%20from%20a%20side%20window%2C%20minimalist%20aesthetic%20product%20photography%20with%20organic%20folds%20and%20natural%20composition&width=160&height=160&seq=cat-img-tshirts-2026&orientation=squarish",
  },
  {
    id: "jackets",
    name: "Jackets",
    namePl: "Kurtki",
    url: "https://kaspreadsheet.com/search-914/name/Shoes.html",
    imageUrl:
      "https://readdy.ai/api/search-image?query=Trendy%20jacket%20and%20stylish%20outerwear%20elegantly%20displayed%20on%20a%20minimal%20wooden%20hanger%20against%20a%20soft%20warm%20beige%20wall%2C%20studio%20lighting%20with%20gentle%20highlights%2C%20high-end%20fashion%20product%20photography%20with%20clean%20elegant%20lines&width=160&height=160&seq=cat-img-jackets-2026&orientation=squarish",
  },
  {
    id: "pants",
    name: "Pants/Shorts",
    namePl: "Spodnie/Szorty",
    url: "https://kaspreadsheet.com/search-915/name/Shoes.html",
    imageUrl:
      "https://readdy.ai/api/search-image?query=Modern%20tailored%20pants%20and%20casual%20shorts%20neatly%20laid%20flat%20on%20a%20warm%20textured%20linen%20surface%2C%20soft%20natural%20light%20creating%20subtle%20gentle%20shadows%2C%20minimalist%20fashion%20product%20photography%20with%20neutral%20cream%20and%20oatmeal%20tones&width=160&height=160&seq=cat-img-pants-2026&orientation=squarish",
  },
  {
    id: "headwear",
    name: "Headwear",
    namePl: "Nakrycia Głowy",
    url: "https://kaspreadsheet.com/search-916/name/Shoes.html",
    imageUrl:
      "https://readdy.ai/api/search-image?query=Stylish%20caps%20and%20fashionable%20headwear%20displayed%20on%20a%20minimal%20clean%20display%20stand%2C%20soft%20diffused%20studio%20lighting%20with%20warm%20undertones%2C%20clean%20neutral%20background%2C%20editorial%20accessory%20photography%20with%20refined%20composition&width=160&height=160&seq=cat-img-headwear-2026&orientation=squarish",
  },
  {
    id: "sets",
    name: "Sets",
    namePl: "Zestawy",
    url: "https://kaspreadsheet.com/search-917/name/Shoes.html",
    imageUrl:
      "https://readdy.ai/api/search-image?query=Coordinated%20matching%20fashion%20outfit%20sets%20displayed%20harmoniously%20on%20a%20minimal%20cream%20backdrop%2C%20soft%20diffused%20lighting%20with%20warm%20tones%2C%20professional%20product%20photography%20with%20elegant%20clothing%20pairings%20and%20clean%20aesthetic&width=160&height=160&seq=cat-img-sets-2026&orientation=squarish",
  },
  {
    id: "underwear",
    name: "Underwear/Underpants",
    namePl: "Bielizna",
    url: "https://kaspreadsheet.com/search-918/name/Shoes.html",
    imageUrl:
      "https://readdy.ai/api/search-image?query=Premium%20underwear%20collection%20neatly%20presented%20on%20soft%20linen%20fabric%20surface%2C%20gentle%20warm%20diffused%20lighting%2C%20minimalist%20textile%20product%20photography%20with%20clean%20delicate%20composition%20and%20subtle%20natural%20textures&width=160&height=160&seq=cat-img-underwear-2026&orientation=squarish",
  },
  {
    id: "jersey",
    name: "Jersey",
    namePl: "Koszulki Sportowe",
    url: "https://kaspreadsheet.com/search-919/name/Shoes.html",
    imageUrl:
      "https://readdy.ai/api/search-image?query=Athletic%20sport%20jersey%20and%20performance%20top%20displayed%20on%20a%20minimal%20clean%20white%20surface%2C%20bright%20clean%20studio%20lighting%2C%20professional%20sports%20apparel%20product%20photography%20with%20dynamic%20yet%20clean%20polished%20composition&width=160&height=160&seq=cat-img-jersey-2026&orientation=squarish",
  },
  {
    id: "accessories",
    name: "Accessories",
    namePl: "Akcesoria",
    url: "https://kaspreadsheet.com/search-920/name/Shoes.html",
    imageUrl:
      "https://readdy.ai/api/search-image?query=Fashion%20accessories%20including%20elegant%20jewelry%20and%20decorative%20wearable%20items%20artfully%20arranged%20on%20a%20smooth%20marble%20surface%2C%20soft%20warm%20lighting%20with%20gentle%20highlights%2C%20elegant%20product%20photography%20with%20neutral%20cream%20and%20warm%20beige%20background&width=160&height=160&seq=cat-img-accessories-2026&orientation=squarish",
  },
  {
    id: "bags",
    name: "Bags",
    namePl: "Torby",
    url: "https://kaspreadsheet.com/search-921/name/Shoes.html",
    imageUrl:
      "https://readdy.ai/api/search-image?query=Designer%20handbag%20and%20elegant%20leather%20bag%20displayed%20on%20a%20minimal%20shelf%20with%20warm%20ambient%20lighting%2C%20neutral%20beige%20background%2C%20luxury%20accessory%20product%20photography%20with%20soft%20refined%20shadows%20and%20sophisticated%20composition&width=160&height=160&seq=cat-img-bags-2026&orientation=squarish",
  },
  {
    id: "belts",
    name: "Belts",
    namePl: "Paski",
    url: "https://kaspreadsheet.com/search-922/name/Shoes.html",
    imageUrl:
      "https://readdy.ai/api/search-image?query=Premium%20leather%20belt%20elegantly%20coiled%20and%20displayed%20on%20a%20minimal%20warm%20wooden%20surface%2C%20soft%20studio%20lighting%20with%20gentle%20highlights%2C%20professional%20accessory%20product%20photography%20with%20clean%20refined%20composition%20and%20neutral%20background&width=160&height=160&seq=cat-img-belts-2026&orientation=squarish",
  },
  {
    id: "perfumes",
    name: "Perfumes",
    namePl: "Perfumy",
    url: "https://kaspreadsheet.com/search-923/name/Shoes.html",
    imageUrl:
      "https://readdy.ai/api/search-image?query=Elegant%20perfume%20bottle%20with%20golden%20accents%20displayed%20on%20a%20smooth%20marble%20surface%2C%20soft%20warm%20ambient%20lighting%20creating%20gentle%20reflections%2C%20luxurious%20atmosphere%2C%20neutral%20cream%20background%2C%20high-end%20fragrance%20product%20photography&width=160&height=160&seq=cat-img-perfumes-2026&orientation=squarish",
  },
  {
    id: "other",
    name: "Other Stuff",
    namePl: "Inne Produkty",
    url: "https://kaspreadsheet.com/search-924/name/Shoes.html",
    imageUrl:
      "https://readdy.ai/api/search-image?query=Assorted%20lifestyle%20products%20and%20miscellaneous%20gadgets%20creatively%20arranged%20on%20a%20clean%20warm%20white%20surface%2C%20soft%20natural%20lighting%2C%20minimalist%20eclectic%20product%20photography%20with%20warm%20neutral%20aesthetic%20and%20organic%20composition&width=160&height=160&seq=cat-img-other-2026&orientation=squarish",
  },
];